import { Button, Color, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { View, StyleSheet, ViewProps } from 'react-native'
import { Trans } from 'react-i18next'
import { NormalizedCompanyColorScheme, Schedule } from 'zens-store'

import { FloorField } from '../floor'
import { ZoneField } from '../zone'
import { BuildingField } from '../building'
import { UserActivity } from '../user'

import ScheduleProgram from './program'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  top: {
    padding: Spacing.S,
    borderBottomWidth: 1,
    borderBottomColor: Color.calmGrey,
  },
  content: {
    padding: Spacing.M,
  },
  space: {
    color: Color.metalGrey,
    marginLeft: 0,
    marginRight: 0,
  },
  activity: {
    height: 50,
    justifyContent: 'flex-end',
  },
  edit: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: Spacing.M,
  },
  skeletonProgram: {
    height: 98,
    backgroundColor: Color.sleepingGrey,
    borderRadius: Radius.XS,
  },
})

interface Props extends ViewProps {
  schedule: Schedule
  colorScheme: NormalizedCompanyColorScheme
}
const ScheduleCard = (props: Props) => {
  const { schedule, colorScheme, style, ...otherProps } = props
  const {
    name,
    companyId,
    buildingId = NaN,
    floorId = NaN,
    zoneId = NaN,
    createdBy,
    createdAt,
    updatedBy,
    updatedAt,
    visualProgram,
  } = schedule
  const textForSpace = () => {
    if (zoneId)
      return (
        <Trans>
          Active on <ZoneField companyId={companyId} value={zoneId} level={7} style={styles.space} />
        </Trans>
      )
    else if (floorId) {
      return (
        <Trans>
          Active on <FloorField companyId={companyId} value={floorId} level={7} style={styles.space} />
        </Trans>
      )
    } else if (buildingId) {
      return (
        <Trans>
          Active on <BuildingField companyId={companyId} value={buildingId} level={7} style={styles.space} />
        </Trans>
      )
    }
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.top}>
        <ScheduleProgram program={visualProgram} colorScheme={colorScheme} />
      </View>
      <View style={styles.content}>
        <Text level={4}>{name}</Text>
        <Text level={7} style={styles.space}>
          {textForSpace()}
        </Text>
        <View style={styles.activity}>
          {updatedAt ? (
            <UserActivity companyId={companyId} activity="updated" date={updatedAt} userId={updatedBy} />
          ) : (
            createdAt && <UserActivity companyId={companyId} activity="added" date={createdAt} userId={createdBy} />
          )}
        </View>
      </View>
    </View>
  )
}

interface SkeletonProps extends ViewProps {}

ScheduleCard.Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.top}>
        <View style={styles.skeletonProgram} />
      </View>
      <View style={styles.content}>
        <Text.Skeleton level={4} />
        <Text.Skeleton level={7} style={styles.space} />
        <View style={styles.activity}>
          <Text.Skeleton />
        </View>
        <View style={styles.edit}>
          <Button.Skeleton />
        </View>
      </View>
    </View>
  )
}

export default ScheduleCard
